import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static values = {
    options: Object,
    isCreatable: {
      type: Boolean,
      default: false
    },
    textOptions: Array
  }

  connect() {
    this.attach();
  }

  disconnect() {
    this.slimselect.destroy();
  }

  attach() {
    if (this.slimselect) this.slimselect.destroy();

    // Browser translation rewrites the hidden select's options, which SlimSelect answers with a change
    // event, re-submitting auto-submit forms in a loop.
    this.element.setAttribute("translate", "no");

    let events = {
      afterChange: () => {
        this.element.dispatchEvent(
          new CustomEvent('input', {
            bubbles: true,
          })
        )
      },
    }


    if (this.isCreatableValue) {
      let texts = this.textOptionsValue
      events = {
        ...events,
        addable: function (value) {
          if (texts.includes(value)) {
            return false;
          }

          return {
            text: value,
            value: value
          }
        }
      }
    }

    const selectData = {
      select: this.element,
      events: events,
      ...this.optionsValue
    }
    if (selectData['scrollBack']) {
      selectData['events']['afterOpen'] = () => {
        // bug fix: page thrown off screen when opening select
        window.scrollTo(0, 0);
      }
      delete selectData['scrollBack'];
    }

    this.slimselect = new SlimSelect(selectData);
  }
}
